<!-- ========================== intro (start) ========================== -->

<main class="l-deashboard summary" [formGroup]="summaryForm">

		<div class="h100 t-boxMargin" *ngIf="ls.isCardio" style='padding-right: 0.87em; padding-left: 0.87em;'>

			<!-- cell : recommendations -->
			<app-diagnoses group="summary" [form]="summaryForm.get('DiagnosisCodes')" [text]="summaryForm.get('Anomalies')" class="w100 summary-boxHeight summary-extradocs" autoid="51" [close]="closeSubject" [textonly]="true"></app-diagnoses>
		</div>
		<div class="h100 l-flex-w t-boxMargin--spacebyPadding" [style]="ls.isCardio ? 'margin-top: 2em':''">
			<div class="w50 summary-spreadHeight summary-recommendations" *ngIf="! ls.isCardio && es.ExamType !=='Fetal Echo' && es.ExamType !='CVS' && es.ExamType !='Amniocentesis' && es.ExamType !='Follicles'">
                    <div class="m-box" style="min-height: 5em;" *ngIf="es.ExamType !='CVS' && es.ExamType !='Amniocentesis' && es.ExamType !='Follicles'">

                            <h2>
                                Indicative Way of Examination
                            </h2>
        
                            <div class="l-flex-c l-flex-w indicative-fieldset h100">
                                
                                <label class="t-label-top">
        
                                    <input type="checkbox" formControlName="Abdominal" class="custom-check -sq"/>
                                    <i class="customInput-display -sq"></i>
                                    <span>
                                        Abdominal
                                    </span>
        
                                </label>
        
                                <label class="t-label-top">
        
                                    <input type="checkbox"  formControlName="Vaginal" class="custom-check -sq"/>
                                    <i class="customInput-display -sq"></i>
                                    <span>
                                        Vaginal
                                    </span>
        
                                </label>
        
                                <label class="t-label-top">
        
                                    <input type="checkbox" formControlName="Transperineal" class="custom-check -sq"/>
                                    <i class="customInput-display -sq"></i>
                                    <span>
                                        Transperineal
                                    </span>
        
                                </label>
                                
                                <label class="t-label-top">
        
                                    <input type="checkbox" formControlName="Rectal" class="custom-check -sq"/>
                                    <i class="customInput-display -sq"></i>
                                    <span>
                                        Rectal
                                    </span>
        
                                </label>
                                                                                                                    
                            </div>
                            
                        </div>
        
			</div>

			<div class="w50 summary-spreadHeight summary-recommendations" *ngIf="ls.isCardio || es.ExamType ==='Fetal Echo'">
				<div class="m-box">

						<h2>
							Imaging Quality
						</h2>
	
						<div class="l-flex-c l-flex-w indicative-fieldset h100" style="justify-content: space-evenly;min-height: 2.33em">
							<label class="t-label-top">
		
								<input type="radio" formControlName="ImagingQuality" value="Poor" class="custom-check -sq" />
								<i class="customInput-display -sq"></i>
								<span>
									Poor
								</span>
		
							</label>
		
							<label class="t-label-top">
								<input type="radio" formControlName="ImagingQuality" value="Fair" class="custom-check -sq" />
								<i class="customInput-display -sq"></i>
								<span>
									Fair
								</span>
							</label>
		
							<label class="t-label-top">
								<input type="radio" formControlName="ImagingQuality" value="Good" class="custom-check -sq" />
								<i class="customInput-display -sq"></i>
								<span>
									Good
								</span>
							</label>
						</div>
						
					</div>
	
			

			</div>

			<!-- endcell : recommendations -->
			
			<!-- CELL : DIAGNOSIS -->

			<div class="w50 summary-indicative">
				<div class="m-box" style='padding-top: 0.5em;padding-bottom: 0.5em;'>

						<h2 style="top: -1em">
							Referring Doctor
						</h2>
						
						<textarea class="fulltext" style="width: 100%;background: none;border: none;min-height: 4em;height: 100%;" formControlName="ReferingDoc"></textarea>
						<button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(summaryForm.get('ReferingDoc'),'Referring Doctor',3)">Auto Text</button>
						
						
					</div>
			
			</div>
			<!-- endcell : diagnosis -->
					
			<!-- cell : Diagnosis -->
			<div class="w50 summary-boxHeight summary-indicative" style="height: auto;" *ngIf="! ls.isCardio && es.ExamType !='CVS' && es.ExamType !='Amniocentesis' && es.ExamType !='Follicles'">
				<app-diagnoses group="summary" [form]="summaryForm.get('DiagnosisCodes')" [formGroup]="summaryForm" insummary="true"
					[text]="summaryForm.get('Anomalies')" class="w100 summary-boxHeight summary-extradocs" autoid="51">
				</app-diagnoses>
			</div>
			<!-- endcell : Diagnosis -->

			<!-- cell : indicative way of examination -->
			
			<div class="w50 summary-boxHeight summary-indicative" [ngClass]="(es.ExamType !='CVS' && es.ExamType !='Amniocentesis' && es.ExamType !='Follicles') ? 'autoHeight' : ''">
				<section class="m-box">
	
					<h2>
						Recommendations
					</h2>
					<textarea class="scroller" formControlName="Recomm"></textarea>
					<button class="t-btn-edit" *ngIf="! es.isClosed && lastRecommendations" (click)="addLastRecomm()"
						style="margin-right: 6em">Previous Recommendations</button>
					<button class="t-btn-edit" *ngIf="! es.isClosed"
						(click)="atS.showAuto(summaryForm.get('Recomm'),'Recommendations',5)">Auto Text</button>

				</section>
			</div>

			<!-- CELL : REPEAT EXAMINATION -->
			<div class="summary-repeatExamination" [ngClass]="ls.isCardio? 'w50':'w100'">

				<section class="m-box">

					<div class="l-flex-c h100">
						
						<div class="l-fg1 repeatExamination-text">
							Schedule Followup  
							<select class="t-select t-field" formControlName="FollowUpExam">
								<option></option>
								<ng-container *ngIf="ls.isCardio">
									<option value="TTE Adults">TTE Adults</option>
									<option value="Stress-Echo">Stress-Echo</option>
									<option value="Duplex Carotid">Duplex Carotid</option>
									<option value="Stress">Stress</option>
									<option value="Holter ECG">Holter ECG</option>
									
								</ng-container>
								
							</select>
							in 

							<span class="t-highlight-glowingCircle">
								<input type="number" min="1" max="40"  style='width: 2em; background: none; border: none; color: white; font-size: 1.1em;margin-left: .7em;' formControlName="Repeat1">
							</span>
							
							<select class="t-select t-field" formControlName="Repeat2">
								<option></option>
								<option value="days">Days</option>
								<option value="weeks">Weeks</option>
								<option value="months">Months</option>
							</select>
						</div>
					</div>

				</section>



			</div>
		<!-- endcell : referring doctor -->

		<!-- cell : indicative way of examination -->

		

		
		<!-- ENDCELL : REPEAT EXAMINATION -->

		<!-- cell : referring doctor -->

		<div class="w50 summary-boxHeight summary-referringDr" *ngIf="! ls.ishospital">
			<section class="m-box" (dblclick)="summaryForm.get('HMO').setValue(-1)">

				<h2>
					HMO
				</h2>
				<div class="l-flex-c l-flex-w indicative-fieldset h100">
					<label class="t-label-top">

						<input type="radio" formControlName="HMO" value="Leumit" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Leumit
						</span>

					</label>

					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="Clalit" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Clalit
						</span>
					</label>

					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="Macabi" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Macabi
						</span>
					</label>

					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="Meuhedet" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Meuhedet
						</span>
					</label>
					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="Private" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Private
						</span>
					</label>
					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="הפניקס" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Phoenix
						</span>
					</label>
					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="כלל" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Clal
						</span>
					</label>
					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="איילון" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Ayalon
						</span>
					</label>
					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="הכשרה ביטוח" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Hachshara Insurance
						</span>
					</label>
					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="מנורה" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Menora
						</span>
					</label>
					<label class="t-label-top">
						<input type="radio" formControlName="HMO" value="מגדל" class="custom-check -sq" />
						<i class="customInput-display -sq"></i>
						<span>
							Migdal
						</span>
					</label>
				</div>

			</section>



		</div>
		<!-- endcell : referring doctor -->


		<!-- cell : indicative way of examination -->
		
		<div class="w50 summary-boxHeight summary-indicative" *ngIf="! ls.ishospital && summaryForm.get('HMO').value == 'Leumit' && ls.hasLeumit">
			<section class="m-box">

					<h2>
						PRN & Treatment Code
					</h2>
					<div class="l-flex-c l-flex-w indicative-fieldset h100">
						<label class="t-label-top">
							<span>
								Payer Reference Num
							</span>
							<span class="t-field t-field--number">
								<input class="t-field-text" formControlName="PRN" (keyup)="checklength()" [ngClass]="prnerr? 'is-invalid':''"/>
								<div class="t-validation-message">
									<span>{{prnerr}}</span>
								</div>
							</span>
						</label>

						<label class="t-label-top">
							<span>
								Code of Treatment
							</span>
							<span class="t-field t-field--number">
								<input class="t-field-text" formControlName="TreatmentCode" [ngClass]="trerr? 'is-invalid':''" (keyup)="checklength()"/>
								<div class="t-validation-message">
									<span>Invalid Treament Code</span>
								</div>
							</span>
						</label>

						<button class="save_patieont" (click)="checkPRN()" *ngIf="ls.PRNcheck && checkleumit">
							Check Validity
						</button>
						<div *ngIf="ls.PRNcheck && checkleumit" style="margin-left:auto">Invalid PRNs will not be saved</div>
					</div>
					
				</section>

		</div>
		<!-- cell : Summary -->
		<div [ngClass]="ls.isCardio? 'w50':'w100'">
			<section class="m-box">
		
				<h2>
					Summary of Exam
				</h2>
				<angular-editor  *ngIf="es.ExamType == 'Gynecology'" formControlName='Diagnosis' [config]="editorConfig" style="width: 100%;"></angular-editor>
				
				<textarea class="scroller"  *ngIf="es.ExamType != 'Gynecology'"  formControlName="Diagnosis"></textarea><!-- /scroller -->
				<button class="t-btn-edit" *ngIf="! es.isClosed && lastDiagnosis" (click)="addLastDiagnosis()" style="margin-right: 6em" >Previous Summary</button>
				<button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(summaryForm.get('Diagnosis'),'Diagnosis',4)">Auto Text</button>
				

			</section>
		</div>
		<app-text-box *ngIf="showComment" [data]="summaryForm.get('Diagnosis').value" [form]="summaryForm" type="Diagnosis" ATiD="4" (closed)="showComment = false"></app-text-box>
		<!-- endcell : Summary -->
		<div class="w50 summary-boxHeight summary-referringDr" *ngIf="ls.isCardio">
			<section class="m-box">

				<h2>
					Sign Exam
				</h2>
				<div class="l-flex-c l-flex-w indicative-fieldset h100">
					<button  class="save_patieont" *ngIf="showSign()" (click)="showlock=true">Sign Exam as {{ls.getUserName()}}</button>
					<div *ngIf="showlock && ! es.isClosed">Are you sure this will lock the exam? 
						<span (click)="signClose()" style='margin-left: 2em; cursor: pointer;'>Yes</span>
						<span (click)="showlock=false" style='margin-left: 2em; cursor: pointer;'>Cancel</span>
					</div>
					<span *ngIf="signed">Signed on {{signed | date:'d-M-y H:mm:ss'}} by {{signer}}</span>
				</div>
			</section>
		</div>
		<!-- cell : 	extra documents -->
		<div class="w100 summary-boxHeight summary-extradocs" *ngIf="false">

			<section class="m-box">

				<h2>
					Extra Documents
				</h2>
				<div class="l-flex-c extraDocuments-table h100">

					<div class="l-flex-c l-flex-w extraDocument-cell-wrap">

						<div class="extraDocument-cell">

							<div class="l-fg1">
								<div class="extraDocument-name">
									Document Name
								</div>
								<div class="extraDocument-date">
									19/12/2017
								</div>
							</div>

							<button class="extraDocument-close"></button>

						</div>


						<div class="extraDocument-cell">

							<div class="l-fg1">
								<div class="extraDocument-name">
									Document Name
								</div>
								<div class="extraDocument-date">
									19/12/2017
								</div>
							</div>

							<button class="extraDocument-close"></button>

						</div>


						<div class="extraDocument-cell">

							<div class="l-fg1">
								<div class="extraDocument-name">
									Document Name
								</div>
								<div class="extraDocument-date">
									19/12/2017
								</div>
							</div>

							<button class="extraDocument-close"></button>

						</div>


						<div class="extraDocument-cell">

							<div class="l-fg1">
								<div class="extraDocument-name">
									Document Name
								</div>
								<div class="extraDocument-date">
									19/12/2017
								</div>
							</div>

							<button class="extraDocument-close" aria-label="remove document"></button>

						</div>

					</div>

					<button class="t-btn-grad">
						Add Extra Documents
					</button>


				</div>

			</section>

		</div>
		<!-- endcell : extra documents -->


	</div>

</main>